exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-app-bar .v-toolbar__content{margin:-26px 0 -4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0\n}\n.v-app-bar .v-toolbar__content .icon_container{width:200px\n}\n.v-app-bar.mobile .v-toolbar__content{margin-top:-20px\n}\n", ""]);

// exports
